import styles from './styles.module.sass';

export interface ISiteLogoProps extends React.HTMLAttributes<HTMLDivElement> {
    homeUrl: string;
    LinkComponent: any;
    title: string;
    logoSrc: string;
    logoSrcMobile?: string;
    logoWidth?: number;
    logoHeight?: number;
    logoMobileWidth?: number;
    logoMobileHeight?: number;
}

export function SiteLogo({
    homeUrl,
    logoSrc,
    LinkComponent,
    title,
    logoSrcMobile,
    logoWidth = 77,
    logoHeight = 27,
    logoMobileWidth = 92,
    logoMobileHeight = 32,
    ...props
}: ISiteLogoProps) {
    const Link = ({ logoSrc, width, height }: { logoSrc: string | undefined; width: number; height: number }) => (
        <LinkComponent data-test-id={'site-logo'} href={homeUrl}>
            {title}
            <img
                data-test-id={'site-logo-img'}
                src={logoSrc}
                alt="Site logo"
                width={width}
                height={height}
                decoding="async"
                fetchPriority="high"
            />
        </LinkComponent>
    );

    return (
        <div {...props} className={styles.logos + ' ' + (props.className || '')}>
            {/*
                Two logo elements - one for mobile screen and one for tablet and bigger. Two elements with different
                classes are needed so that CSS media queries can be used to show/hide logos for different screen
                sizes.
                If `src` provided for one logo only, say mobile, it is used in second element also (for bigger screens)
            */}
            <strong className={styles.logo}>
                <Link logoSrc={logoSrc || logoSrcMobile} width={logoWidth} height={logoHeight} />
            </strong>
            <strong className={styles.logoMobile}>
                <Link logoSrc={logoSrcMobile || logoSrc} width={logoMobileWidth} height={logoMobileHeight} />
            </strong>
        </div>
    );
}
